import React, { useState } from "react";
import styles from "../styles/cms.module.css";
import { Layout } from "../../../ui";
import PartnerCode from "../components/PartnerCode";
import CouponCode from "../components/CouponCode";
import EmailModal from "../components/EmailModal";
import { sendManualESIMEmail } from "../api";
import { toast } from "react-toastify";
import { LOCAL_CONSTANTS } from "../../../lib/constants/constantsLocal";

const CmsSpecificCountry = () => {
  const [cmsType, setCMSType] = useState<number>(2);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const roles = window.localStorage.getItem("admin_roles");


  return (
    <Layout title="History">
      <div className={styles.cms}>
        <div className={styles.topCms}>
          <ul>
            {LOCAL_CONSTANTS.ROLES.HUONG !== Number(roles) && <li
              className={cmsType === 1 ? styles.active : ""}
              onClick={() => setCMSType(1)}
            >
              <p>Partner</p>
            </li>}

            <li
              className={cmsType === 2 ? styles.active : ""}
              onClick={() => setCMSType(2)}
            >
              <p>Coupon Code</p>
            </li>
          </ul>
          
          {/* <button 
            className={styles.sendEmailBtn}
            onClick={() => setIsEmailModalOpen(true)}
          >
            Send eSIM Email
          </button> */}
        </div>

        {cmsType === 1 ? <PartnerCode /> : null}
        {cmsType === 2 ? <CouponCode /> : null}

        {/* <EmailModal
          isOpen={isEmailModalOpen}
          onClose={() => setIsEmailModalOpen(false)}
          onSubmit={handleEmailSubmit}
        /> */}
      </div>
    </Layout>
  );
};

export default CmsSpecificCountry;
